'use client';

import { Stack } from '@mantine/core';
import { Bets } from '../Bets';
import { BattlesBanner } from './BattlesBanner';
import { BattlesList } from './BattlesList';
export const Battles: React.FC = () => {
  return <Stack gap={20}>
      <BattlesBanner />
      <BattlesList />
      <Bets hasActionTab />
    </Stack>;
};